import React from 'react';
import i18next from 'i18next';

import DossierFull from './Full';
import DossierTeaser from './Teaser';

const Dossier = ({ entity, viewMode, ...props }) => {
  const { t } = i18next;

  const today = new Date();
  const effectDate = new Date(entity.getIn(['field_date_only', 0, 'value']));
  const effectDateIsCertain = entity.getIn(['field_is_certain', 0, 'value']);

  const effectDateInFuture = effectDateIsCertain
    ? t('node.dossier.effect_date')
    : t('node.dossier.expected_effect_date');

  const effectDateLabel = `${today < effectDate
    ? effectDateInFuture
    : t('node.dossier.in_effect_since')
  }`;

  const effectDateString = `${effectDate.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' })}`;

  switch (viewMode) {
    case 'teaser':
      return (<DossierTeaser entity={entity} dateLabel={`${effectDateLabel} ${effectDateString}`} {...props} />);
    case 'full':
    default:
      return (<DossierFull entity={entity} dateLabel={`${effectDateLabel} ${effectDateString}`} {...props} />);
  }
};

export default Dossier;
